/**
 * See: https://github.com/sindresorhus/file-type/blob/6f901bd82b849a85ca4ddba9c9a4baacece63d31/core.js#L428-L438
 */
export function isHeic(buffer: Uint8Array) {
  const brandMajor = String.fromCharCode(...buffer.slice(8, 12))
    .replace('\0', ' ')
    .trim();

  const brands = {
    mif1: true,
    msf1: true,
    heic: true,
    heix: true,
    hevc: true,
    hevx: true,
  };

  return brands[brandMajor] || false;
}
